import { render, staticRenderFns } from "./HistoryAndMore.vue?vue&type=template&id=22f34191&scoped=true&"
import script from "./HistoryAndMore.vue?vue&type=script&lang=js&"
export * from "./HistoryAndMore.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAndMore.vue?vue&type=style&index=0&id=22f34191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f34191",
  null
  
)

export default component.exports